import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaUser } from "react-icons/fa";

// Components
import LogoMarquee from "../components/LogoMarquee";

// Team Images
import founder from "../assets/our team/Founder & Principal Investor.jpeg";
import director from "../assets/our team/Director.jpeg";
import Chief from "../assets/our team/Chief Operating Officer.jpeg";
import ABF from "../assets/our team/Adivsory Board Finance.jpeg";
import ABE from "../assets/our team/Advisory Board Education .jpeg";
import ABP from "../assets/our team/Advisory Board Premises.jpeg";
import ABM from "../assets/our team/Advisory Board Management.jpeg";
import Finance from "../assets/our team/Finance and compliance  officer.jpeg";
import FManger from "../assets/our team/Former manager.jpeg";
import Manager from "../assets/our team/Manager.jpeg";
import AM1 from "../assets/our team/Assistant Manager1.jpeg";
import AM2 from "../assets/our team/Assistant Manager2.jpeg";
import EX1 from "../assets/our team/Executive Trainer1.jpeg";
import Manager1 from "../assets/our team/Manager1.jpeg";
import AM3 from "../assets/our team/Assistant Manager3.jpeg";
import EX2 from "../assets/our team/Executive trainer2.jpeg";
import EX3 from "../assets/our team/Executive trainer3.jpeg";

export default function OurTeam() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fadeInUp = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (
        <div className="page-container" style={{ overflowX: "hidden", background: "#f8fafc", minHeight: "100vh" }}>
            {/* 1. HEADER HERO */}
            <section className="page-hero" style={{ padding: '160px 0 80px', background: 'var(--blue2)', color: 'white', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', inset: 0, backgroundImage: 'url("https://www.transparenttextures.com/patterns/cubes.png")', opacity: 0.1, zIndex: 1 }}></div>
                <div className="container" style={{ position: 'relative', zIndex: 10, maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <motion.div initial="hidden" animate="visible" variants={fadeInUp}>
                        <span style={{ fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '2px', color: 'rgba(255,255,255,0.8)', display: 'block', marginBottom: '16px' }}>Our Team</span>
                        <h1 style={{ fontSize: '56px', fontWeight: '800', marginBottom: '24px', letterSpacing: '-1px' }}>The Minds Behind RAMB</h1>
                        <p style={{ fontSize: '20px', opacity: 0.9, maxWidth: '700px', margin: '0 auto', lineHeight: 1.6 }}>
                            Our success is driven by a team of experienced leaders, dedicated advisors, and passionate professionals committed to your financial well-being.
                        </p>
                    </motion.div>
                </div>
            </section>

            {/* 2. TEAM SECTION (ORG CHART) */}
            <section id="org-chart" className="section-padding" style={{ padding: "100px 0" }}>
                <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <motion.div
                        className="section-header center"
                        style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto 60px' }}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInUp}
                    >
                        <h2 style={{ fontSize: '36px', fontWeight: '800', color: '#0f172a', marginBottom: '20px' }}>Corporate Organizational Structure</h2>
                        <p style={{ fontSize: '16px', lineHeight: 1.7, color: '#475569' }}>
                            RAMB structure — leadership, advisory boards, and operations.
                        </p>
                    </motion.div>

                    <OrgChart />
                </div>
            </section>

            {/* 3. LOGO MARQUEE */}
            <LogoMarquee />
        </div>
    );
}

/* ---------------------------
   Org Chart
---------------------------- */
function OrgChart() {
    const [selectedImage, setSelectedImage] = useState(null);

    const data = {
        leadership: [
            { name: "Mrs. M. Abreame", role: "Founder & Principal Investor", img: founder },
            { name: "Mr. V. Thillainadarajah", role: "Chief Executive Officer (CEO)", img: director },
            { name: "Mrs. T. Thillainadarajah", role: "Chief Operating Officer (COO)", img: Chief },
        ],
        advisory: [
            { name: "Ms. Amirthini", role: "Advisory Board – Finance", img: ABF },
            { name: "Mr. Baskaran", role: "Advisory Board – Education", img: ABE },
            { name: "Mr. Janagan", role: "Advisory Board – Premises", img: ABP },
            { name: "Mr. Anoshan", role: "Advisory Board – Management", img: ABM },
        ],
        finance: [{ name: "Ms. Keerthika", role: "Finance & Compliance Officer", img: Finance }],
        operationsLabel: "Operations Team: Admin | Field | Support Staff",
        operations: [
            { name: "Mr. Sethukanan (Former)", role: "Manager", img: FManger },
            { name: "Ms. Subasihin", role: "Manager (Associate Principal)" },
            { name: "Ms. Kema", role: "Teacher" },
            { name: "Ms. Selvasri Questalla", role: "Manager", img: Manager },
            { name: "Mr. Kirujan", role: "Assistant Manager", img: AM1 },
            { name: "Ms. Kamsika", role: "Executive Trainer", img: EX1 },
            { name: "Ms. Kajeni", role: "Manager", img: Manager1 },
            { name: "Ms. Prinsiya", role: "Assistant Manager", img: AM2 },
            { name: "Mr. Nilavan (Former)", role: "Assistant Manager", img: AM3 },
            { name: "Mr. Theesikan", role: "Executive Trainer", img: EX2 },
            { name: "Ms. A Arunya", role: "Executive Trainer", img: EX3 },
        ],
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '40px', marginTop: '40px' }}>

            {/* LEADERSHIP */}
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}>
                {data.leadership.map((p, i) => <OrgNode key={i} person={p} delay={i * 0.1} onImageClick={setSelectedImage} />)}
            </div>

            {/* STEM */}
            <div style={{ width: '2px', height: '40px', background: 'var(--blue2)' }}></div>

            {/* ADVISORY */}
            <h3 style={{ fontSize: '20px', fontWeight: '700', color: 'var(--blue2)', textTransform: 'uppercase', letterSpacing: '1px' }}>Advisory Boards</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}>
                {data.advisory.map((p, i) => <OrgNode key={i} person={p} delay={i * 0.1} onImageClick={setSelectedImage} />)}
            </div>

            {/* STEM */}
            <div style={{ width: '2px', height: '40px', background: 'var(--blue2)' }}></div>

            {/* FINANCE */}
            <h3 style={{ fontSize: '20px', fontWeight: '700', color: 'var(--blue2)', textTransform: 'uppercase', letterSpacing: '1px' }}>Finance & Compliance</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}>
                {data.finance.map((p, i) => <OrgNode key={i} person={p} delay={i * 0.1} onImageClick={setSelectedImage} />)}
            </div>

            {/* STEM */}
            <div style={{ width: '2px', height: '40px', background: 'var(--blue2)' }}></div>

            {/* OPERATIONS */}
            <h3 style={{ fontSize: '20px', fontWeight: '700', color: 'var(--blue2)', textTransform: 'uppercase', letterSpacing: '1px', textAlign: 'center' }}>{data.operationsLabel}</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px', maxWidth: '1000px' }}>
                {data.operations.map((p, i) => <OrgNode key={i + 10} person={p} delay={i * 0.05} compact onImageClick={setSelectedImage} />)}
            </div>

            {/* IMAGE MODAL */}
            {selectedImage && (
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                        zIndex: 99999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px',
                        cursor: 'pointer'
                    }}
                    onClick={() => setSelectedImage(null)}
                >
                    <motion.img
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.8 }}
                        src={selectedImage}
                        alt="Team Member"
                        style={{
                            maxWidth: '90vw',
                            maxHeight: '85vh',
                            objectFit: 'contain',
                            borderRadius: '16px',
                            boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
                            cursor: 'default'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}

        </div>
    );
}

function OrgNode({ person, delay, compact, onImageClick }) {
    const { name, role, img } = person;

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: delay }}
            style={{
                background: 'white',
                borderRadius: '16px',
                padding: compact ? '20px' : '24px',
                width: compact ? '220px' : '260px',
                textAlign: 'center',
                boxShadow: '0 10px 30px rgba(0,0,0,0.06)',
                border: '1px solid rgba(0,0,0,0.03)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                transition: 'transform 0.2s',
                cursor: img ? 'pointer' : 'default'
            }}
            onClick={() => img && onImageClick(img)}
            whileHover={img ? { transform: 'translateY(-5px)', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' } : {}}
        >
            <div style={{
                width: compact ? '80px' : '100px',
                height: compact ? '80px' : '100px',
                borderRadius: '50%',
                overflow: 'hidden',
                background: '#f1f5f9',
                border: '4px solid white',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                flexShrink: 0
            }}>
                {img ? (
                    <img src={img} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#cbd5e1', fontSize: '32px' }}>
                        <FaUser />
                    </div>
                )}
            </div>
            <div>
                <h4 style={{ fontSize: compact ? '16px' : '18px', fontWeight: '700', color: '#1e293b', marginBottom: '4px' }}>{name}</h4>
                <div style={{ fontSize: '14px', color: '#64748b', lineHeight: 1.4 }}>{role}</div>
            </div>
        </motion.div>
    );
}